import { UserPreferenceAssetResponse } from "../../../../@types/UserPreferences";
import { api } from "../../../api";

export default async function all(): Promise<
  UserPreferenceAssetResponse | undefined
> {
  try {
    const { data } = await api.get("/user/preferences");

    if (data.status === 1) {
      return data;
    }
  } catch (err) {
    console.log(err);
  }
}
